/**
 *
 * @class {SectionUserContent.Add}
 * @extends {SectionUserContentBase}
 */
SectionUserContent.Add = Class(
	/**
	 * @lends {SectionUserContent.Add#}
	 */
	{
		bodyClass: 'small-nav grey hide-tablet-footer full-container',

		_draw: function() {
			this.rpc.send(
				'getMyContent',
				{
					pg: 0,
					count: 0
				},
				this._getMyContentRe
			);
		},

		_getMyContentRe(re) {
			if (re.userTaskLimit >= 0 && re.total >= re.userTaskLimit) {
				Section.navigate('/user-content/my');
				return;
			}
			new SectionUserContent.Wizard({
				eventId: SectionUserContent.EVENT_ID
			}).append(this._mainContentNode);
			this.ready();
		}
	},
	SectionUserContentBase
);